

import { styled } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

export type ColourGridCellValueType = {
  text: string
  cellStyle?: {
    backgroundColor?: string
    color?: string
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ColourGridCellProps = GridRenderCellParams<any, ColourGridCellValueType> & {
  //
}

export const ColourGridCell: React.FC<ColourGridCellProps> = ({ value }) => {
  return (
    <StyledContainer
      sx={value?.cellStyle}
    >
      {value?.text}
    </StyledContainer>
  )
}

const StyledContainer = styled('div')`
  width: calc(100% + 20px);
  padding: 0 10px;
  margin: 0 -10px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
`
